import { FC, useState } from 'react';
import { BonusMenuItemEntity } from '../Components/BonusMenuItem/types';
import { useTranslation } from 'react-i18next';
import {
    bonusUsersIcon,
    bonusLinkIcon,
    mellIcon,
    mellBg,
    lockIcon,
    lockBg,
    marketWhite,
    disableWallet,
    prizeWhite,
    ilIcon,
    ilIcon2,
} from '../../../assets';
import BonusEarnDetails from '../Components/BonusEarnDetails/BonusEarnDetails';
import BonusMenuItem from '../Components/BonusMenuItem/BonusMenuItem';

import { useSelector } from 'react-redux';
import { TRootState } from '../../../store/store';
import { formatNumberString, getToken, onImagesLoad } from '../../../utils/helper';

import Modal from '../../../components/Modal/Modal';
import RefBonus from './RefBonus';
import { BonusPage } from '../types';
import RefLink from './RefLink';
import Holders from './Holders';

import { useNavigate } from 'react-router';

const Main: FC<{}> = () => {
    const distribution = useSelector((state: TRootState) => state.distribution.value);
    const [page, setPage] = useState<BonusPage | null>(null);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const menuItems: BonusMenuItemEntity[] = [
        { icon: bonusUsersIcon, title: t('get_bonus'), page: BonusPage.BONUS_PAGE },
        { icon: bonusLinkIcon, title: t('link'), page: BonusPage.LINKS_PAGE },
        { icon: bonusUsersIcon, title: t('my_holders'), page: BonusPage.HOLDERS_PAGE },
        { icon: prizeWhite, title: t('market'), link: '/market' },
    ];

    function getPage() {
        switch (page) {
            case BonusPage.LINKS_PAGE:
                return <RefLink />;
            case BonusPage.BONUS_PAGE:
                return <RefBonus />;
            case BonusPage.HOLDERS_PAGE:
                return <Holders />;

            default:
                break;
        }
    }

    function getTitle() {
        switch (page) {
            case BonusPage.LINKS_PAGE:
                return t('links_header');
            case BonusPage.BONUS_PAGE:
                return t('bonus_header');
            case BonusPage.HOLDERS_PAGE:
                return t('holders_header');
            default:
                break;
        }
    }

    return (
        <>
            <div>
                <div className="bonus__details">
                    <BonusEarnDetails
                        icon={mellIcon}
                        value={
                            distribution && distribution.incomeBonusesStatistics?.earnedValue
                                ? formatNumberString(distribution.incomeBonusesStatistics?.earnedValue)
                                : '0'
                        }
                        title={t('earn')}
                        bgIcon={mellBg}
                        bgIconPosition={{ top: '15px', right: '7.3px' }}
                    />
                    <BonusEarnDetails
                        icon={lockIcon}
                        value={distribution && distribution.incomeBalanceFrozen ? formatNumberString(distribution.incomeBalanceFrozen) : '0'}
                        title={t('hold')}
                        bgIcon={lockBg}
                        bgIconPosition={{ top: '8px', right: '-3px' }}
                    />
                </div>
                <div className="bonus__menu">
                    {menuItems.map(
                        (item) =>
                            !item?.hidden && (
                                <BonusMenuItem
                                    onClick={() => {
                                        if (item.page !== undefined) {
                                            if (item.page === BonusPage.BONUS_PAGE) {
                                                onImagesLoad([ilIcon], () => item.page && setPage(item.page));
                                                return;
                                            }
                                            if (item.page === BonusPage.LINKS_PAGE) {
                                                onImagesLoad([ilIcon2], () => item.page && setPage(item.page));
                                                return;
                                            }
                                            setPage(item.page);
                                        }

                                        if (item.link) {
                                            navigate(item.link);
                                        }
                                    }}
                                    key={item.title}
                                    {...item}
                                />
                            )
                    )}
                </div>
            </div>

            {page && (
                <Modal
                    cross
                    title={getTitle()}
                    closeBtn={() => setPage(null)}
                    classModal="bonus-modal">
                    {getPage()}
                </Modal>
            )}
        </>
    );
};

export default Main;
